'use client';

import { IGoodsListPageInitialData } from '@/api/types/product';
import GoodsListPageClient from '@/app/[variants]/goods-list/[id]/page.client';

export default function CrowdProductList({
  initialData,
  groupId,
  searchParams,
}: {
  initialData: IGoodsListPageInitialData;
  groupId: number;
  searchParams: any;
}) {
  // console.log('initialData, ', initialData);
  return (
    <div className="min-h-screen bg-[#ffffff]">
      {initialData && (
        <GoodsListPageClient
          initialData={initialData}
          crowdListId={groupId}
          searchParams={searchParams}
          useGroupPath={false}
        />
      )}
    </div>
  );
}
